"use client";

import React from 'react';
import { Check, ArrowRight, Star, ShieldCheck, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from '@/components/common/Link';
export default function PrumyslovePraniProVasByznys() {
  return <section id="průmyslové-praní-pro-váš-byznys" className="relative w-full min-h-[90vh] flex items-center bg-background overflow-hidden py-12 lg:py-0">
      {}
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
        .text-glow {
          text-shadow: 0 0 30px rgba(var(--primary), 0.3);
        }
        .btn-glow {
          box-shadow: 0 0 20px rgba(var(--primary), 0.4);
        }
        .btn-glow:hover {
          box-shadow: 0 0 30px rgba(var(--primary), 0.6);
        }
      `}</style>

      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="flex flex-col space-y-8 text-center lg:text-left">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium w-fit mx-auto lg:mx-0">
                <Star className="w-4 h-4 fill-primary" />
                <span>S-clean prádelna Vršovice</span>
              </div>
              
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-primary leading-[1.1] text-glow">
                Prémiové <br />
                <span className="text-foreground">průmyslové praní v Praze</span>
              </h1>
              
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto lg:mx-0 leading-relaxed">Váš spolehlivý partner v Praze ve Vršovicích. S použitím špičkových průmyslových stojů a certifikovaných pracích procesů, zajišťujeme nekompromisní čistotu a hygienu pro hotely, restaurace, Airbnb a wellness centra s vlastní noční logistikou.</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button asChild size="lg" className="h-14 px-8 text-lg rounded-full btn-glow transition-all duration-300">
                <Link to="/ContactPage">
                  Získat nezávaznou nabídku
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg rounded-full border-primary/20 hover:bg-primary/5">
                <Link to="/LogisticsPage">
                  Jak funguje doprava?
                </Link>
              </Button>
            </div>

            {}
            <div className="pt-8 border-t border-border/50">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm font-medium text-muted-foreground">
                <div className="flex items-center justify-center lg:justify-start gap-2">
                  <div className="p-2 bg-primary/10 rounded-full text-primary">
                    <Check className="w-4 h-4" />
                  </div>
                  <span>10+ let zkušeností v praní prádla</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start gap-2">
                  <div className="p-2 bg-primary/10 rounded-full text-primary">
                    <ShieldCheck className="w-4 h-4" />
                  </div>
                  <span>Hygienické standardy</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start gap-2">
                  <div className="p-2 bg-primary/10 rounded-full text-primary">
                    <Clock className="w-4 h-4" />
                  </div>
                  <span>Noční doručení prádla</span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="relative flex justify-center items-center lg:justify-end">
            {}
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-secondary/20 rounded-[40%_60%_70%_30%_/_40%_50%_60%_50%] blur-2xl transform scale-110 animate-pulse" />
            
            {}
            <div className="relative w-full max-w-[600px] aspect-square animate-float">
              <div className="w-full h-full rounded-[30%_70%_70%_30%_/_30%_30%_70%_70%] overflow-hidden shadow-2xl border-4 border-white/50 bg-white relative z-10 transform transition-transform hover:scale-[1.02] duration-500">
                <div className="w-full h-full">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554604/img/hospital_laundry.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554604/img/hospital_laundry.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554604/img/hospital_laundry.png-wvc-sizes" alt="Hospital laundry" className="w-full h-full object-cover" loading="lazy" decoding="async" />
                </div>
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent pointer-events-none mix-blend-overlay" />
              </div>

              {}
              <div className="absolute bottom-[15%] left-[5%] z-20 bg-white/90 backdrop-blur-md p-4 rounded-2xl shadow-lg border border-white/50 max-w-[200px] animate-bounce [animation-duration:3s]">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse" />
                  <span className="text-xs font-bold text-primary uppercase tracking-wider">Status</span>
                </div>
                <p className="text-sm font-medium text-foreground">
                  Linka v provozu <br />
                  <span className="text-muted-foreground text-xs font-normal">Kapacita dostupná</span>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}